import PasswordStrengthBar from "@components/account/PasswordStrengthBar";
import RepeatPasswordBar from "@components/account/RepeatPasswordBar";
import { QuestionTooltip } from "@components/common";
import { useTranslation } from "react-i18next";
import { useState } from "react";

interface PasswordSubFormProps {
  setIsPasswordStrong: (canSubmit: boolean) => void;
  setRepeatedPasswordMatch: (canSubmit: boolean) => void;
  passwordFormId?: string;
  repeatPasswordFormId?: string;
}

export default function PasswordSubForm({
  setIsPasswordStrong,
  setRepeatedPasswordMatch,
  passwordFormId = "password",
  repeatPasswordFormId = "repeatPassword",
}: PasswordSubFormProps) {
  const { t } = useTranslation();
  const [password, setPassword] = useState("");
  const [repeatPassword, setrepeatPassword] = useState("");

  const checkPasswordMatch = (password: string, repeatPassword: string) => {
    if (password === repeatPassword) {
      setRepeatedPasswordMatch(true);
    } else {
      setRepeatedPasswordMatch(false);
    }
  };

  return (
    <>
      <div>
        <div className="flex flex-row items-center">
          <label
            htmlFor="password"
            className="block text-sm font-medium text-gray-700"
          >
            {t("account.common.password")}
          </label>
          <QuestionTooltip
            title={
              t("account.tooltip.passwordStrength", {
                minLength: 8,
              }) as string
            }
            position="top"
          />
        </div>

        <div className="mt-1">
          <input
            id={passwordFormId}
            name={passwordFormId}
            type="password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              // use e.target.value here to compare with the latest value, async setState has a delay
              checkPasswordMatch(e.target.value, repeatPassword);
            }}
            autoComplete="current-password"
            pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!&quot;#$%&'()*+,-./:;<=>?@[\]^_`{|}~])[A-Za-z\d!&quot;#$%&'()*+,-./:;<=>?@[\]^_`{|}~]{8,}"
            onInvalid={(e) =>
              (e.target as HTMLSelectElement).setCustomValidity(
                t("account.tooltip.passwordStrength", {
                  minLength: 8,
                })
              )
            }
            onInput={(e) =>
              (e.target as HTMLSelectElement).setCustomValidity("")
            }
            required
            className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-primary focus:outline-none focus:ring-primary sm:text-sm"
          />
        </div>

        <PasswordStrengthBar
          password={password}
          minLength={8}
          setIsPasswordStrong={setIsPasswordStrong}
        />
      </div>
      {/* Repeat password */}
      <div>
        <label
          htmlFor="repeatPassword"
          className="block text-sm font-medium text-gray-700"
        >
          {t("account.common.repeatPassword")}
        </label>

        <div className="mt-1">
          <input
            id={repeatPasswordFormId}
            name={repeatPasswordFormId}
            type="password"
            autoComplete="repeatPassword"
            value={repeatPassword}
            onChange={(e) => {
              setrepeatPassword(e.target.value);
              // use e.target.value here to compare with the latest value, async setState has a delay
              checkPasswordMatch(password, e.target.value);
            }}
            required
            className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-primary focus:outline-none focus:ring-primary sm:text-sm"
          />
        </div>

        <RepeatPasswordBar
          password={password}
          repeatPassword={repeatPassword}
        />
      </div>
    </>
  );
}
